import React from 'react';
import PropTypes from 'prop-types';

const ToolDrawerHighlights = ({ highlights }) => {
  return (
    <div className="no-scrollbar flex flex-col gap-4 overflow-y-auto py-5">
      {highlights.map(({ hs }) => (
        <div key={hs.id} className="flex items-start justify-between rounded-xl border border-gray-200 p-4">
          <span className="flex-1">{hs.text}</span>
        </div>
      ))}
    </div>
  );
};

ToolDrawerHighlights.propTypes = {
  highlights: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      startMeta: PropTypes.shape({
        parentTagName: PropTypes.string,
        parentIndex: PropTypes.number,
        textOffset: PropTypes.number
      }),
      endMeta: PropTypes.shape({
        parentTagName: PropTypes.string,
        parentIndex: PropTypes.number,
        textOffset: PropTypes.number
      })
    })
  ).isRequired
};

export default ToolDrawerHighlights;
